export default __webpack_public_path__ + "static/media/carte-depuis-2009.68f72e47.png";